import { render, staticRenderFns } from "./ResendEmail.vue?vue&type=template&id=1262a83f&scoped=true"
import script from "./ResendEmail.vue?vue&type=script&lang=js"
export * from "./ResendEmail.vue?vue&type=script&lang=js"
import style0 from "./ResendEmail.vue?vue&type=style&index=0&id=1262a83f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1262a83f",
  null
  
)

export default component.exports